import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/common/errorBoundary'
import Events from '#app/components/events/events.tsx'
import { getAttestationsv2 } from '#app/server/db.server.ts'
import { number } from '#node_modules/zod'

export const loader = async ({
	params,
	context,
	request,
}: LoaderFunctionArgs) => {
	const url = new URL(request.url)
	try {
		const attestations = await getAttestationsv2({
			template_slug: ['rollup'],
		})

		return json({
			eventsData: attestations.attestations,
			count: attestations.count,
			origin: url.origin,
		})
	} catch (e) {
		console.error(e)
		return {
			eventsData: [],
			count: number,
			origin: url.origin,
		}
	}
}

export default function eventsPage() {
	const { eventsData, count, origin } = useLoaderData<typeof loader>()

	return <Events eventsData={eventsData} count={count} origin={origin} />
	// }
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
